module.exports = __webpack_public_path__ + "static/media/error.199b5352.wav";